import React, { useEffect, useState, useContext } from "react";
import Navbar from "./Navbar";
import Banner from "./Banner";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import StateContext from "../StateContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import LazyLoad from "react-lazy-load";
import LoaderAnimation from "./LoaderAnimation";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Button, IconButton } from "@material-ui/core";

import TextField from "@mui/material/TextField";
import promocodeNew from "../Assets/images/promocodeNew.svg";
import useMediaQuery from "@material-ui/core/useMediaQuery";

// import localizations pakeges
import { withTranslation, useTranslation, Trans } from "react-i18next";
import { handleError } from "../Functions/getAlert";
import DispatchContext from "../DispatchContext";

const Loading = () => {
  <div className="post loading">
    <h5>Loading ...</h5>
  </div>;
};
const Rewards = (props) => {
  // console.log(props.amount);
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const minDesktop = useMediaQuery("(min-width: 992px)");
  const [seeMore, setSeeMore] = useState(5);
  const [walletHistory, setWalletHistory] = useState([]);

  // sikandar

  useEffect(() => {
    const fetchHistory = async () => {
      setIsLoading(true);
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}customer/rewards`,
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        setIsLoading(false);
        // console.log(response.data.data);
        setWalletHistory(response.data.data);
        if (response.data.data !== null && response.data.data.length > 0) {
          props.setCount(response.data.data.length);
        }
      } catch (e) {
        handleError(e, appDispatch);
      }
    };
    fetchHistory();
  }, []);

  const handleSeeMore = () => {
    let count = seeMore + 5;
    if (count < walletHistory.length) {
      setSeeMore(count);
    } else if (count > walletHistory.length) {
      setSeeMore(walletHistory.length);
    }
  };

  if (!appState.loggedIn) {
    history.push("/");
  }

  return (
    <>
      {/* <div className="main_area">
                    <div className="container">
                         <div className="main_area_heading text-center">
                              <h2><span className="text-primary">My</span> <span className="text-secondary"><strong>Wallet History</strong></span></h2>
                             
                         </div>
                    
                         <div className="main_area_tabs"> */}
      {/* <NoRewards /> */}
      {/* data-content__dashboard */}
      <div className="data-content__dashboard">
        {/* data-row__dashboard */}
        <div className="data-row__dashboard">
          {!minDesktop ? (
            <div className="container-fluid">
              <div className="row d-flex justify-content-center">
                <div className="col-sm-12 d-flex justify-content-between align-items-center">
                  {" "}
                  <h5 className="">
                    {" "}
                    <strong>{t("dashboard.rewards")} </strong>
                  </h5>{" "}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <Stack spacing={2}>
            {isLoading ? (
              <div style={{ position: "relative", height: "250px" }}>
                <LoaderAnimation />
              </div>
            ) : walletHistory.length > 0 ? (
              <>
                <div className="container-fluid">
                  <div className="row d-flex justify-content-center pl-0 pr-0">
                    {/* <div className="col-sm-8">
                      <TextField
                        onChange={(e) => searchTransactionFunc(e)}
                        fullWidth
                        label="search your transactions"
                        id="fullWidth"
                      />
                    </div> */}
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-center mb-2">
                  {seeMore < walletHistory.length ? (
                    <Button variant="text" onClick={handleSeeMore}>
                      {" "}
                      {"See More"}{" "}
                    </Button>
                  ) : (
                    ""
                  )}{" "}
                </div>
              </>
            ) : (
              <NoRewards t={t} />
            )}
          </Stack>
        </div>
      </div>
    </>
  );
};
function NoRewards(props) {
  // const appState = useContext(StateContext)
  const { t } = props;
  return (
    <>
      <div className="empBox">
        <div className="text-center py-5">
          {/* BoxImg */}
          <div className="BoxImg">
            <img src={promocodeNew} alt="" className="img-fluid" />
          </div>
          <div className="mt-3">
            <p classsName="text-secondary">
              <strong>{t("status.order-not-found")}</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
function HistoryRow(props) {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  // console.log("ssssssss", props.source);

  return (
    <>
      <div className="post">
        <div className="data-row" id={"dep"}>
          <div className="row m-0 align-items-center">
            <div className="col-3 pl-0">
              {props.source === "Invoice" ? (
                <div className="row m-0  pl-3 ">
                  <div className="text pl-2">
                    <p className="text-muted m-0 small">
                      {t("dashboard.sent-by")}
                    </p>
                    <h6 className="m-0">{props.sent_by}</h6>
                  </div>{" "}
                </div>
              ) : (
                <div className="row m-0 align-items-center pl-3 ">
                  <div className="text pl-2">
                    <h6 className="m-0">Top Up at walllet</h6>
                  </div>{" "}
                </div>
              )}
            </div>

            <div className="col-3 text-center p-0">
              <div className="data-row__payment_method_time">
                <div className="row m-0 justify-content-center align-items-center">
                  <div className="row m-0 text-left align-items-center justify-content-center text-center">
                    <div className="payment_method_icon">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}calendar.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div>
                      <p className="small text-muted m-0 text-uppercase">
                        {t("dashboard.processed-on")}
                      </p>
                      <h6 className="time m-0">
                        <strong>{props.created}</strong>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                appState.langValue === "ar" ? "pl-4" : "text-right"
              } col-3 p-0`}
            >
              <div className="data-row__price">
                <h5>
                  <strong
                    className={`${
                      props.source == "Invoice" ? "text-green" : "text-red"
                    }`}
                  >
                    {parseFloat(props.amount)} {t("KWD")}
                  </strong>
                </h5>
                <p className="text-muted m-0 small"> {t("dashboard.source")}</p>
                <h6 className="m-0">{props.source}</h6>
                <div>
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}${props.status}.png`}
                    className="img-fluid"
                    width="30"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              className={`${
                appState.langValue === "ar" ? "pl-4" : "text-right"
              } col-3 p-0`}
            >
              <div className="data-row__price">
                <h5>
                  <strong>Status</strong>
                </h5>
                <p
                  className={`${
                    props.status == "Success"
                      ? "text-green"
                      : props.status == "Pending"
                      ? "text-yellow"
                      : " text-red"
                  } m-0 small`}
                >
                  {" "}
                  {props.status}
                </p>

                <div>
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}${props.status}.png`}
                    className="img-fluid"
                    width="30"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(Rewards);
